import React from "react";
import useAdminBlog from "../hooks/useAdminBlog";
import AdminBlog from "../components/AdminBlog";

const {} = useAdminBlog;

export default function AdminBlogInterface(props) {
  const { onCancelAction, currentItem, callback, canEdit, onSave } = props;

  return (
    <React.Fragment>
      <AdminBlog
        onCancelAction={onCancelAction}
        currentItem={currentItem}
        callback={callback}
        canEdit={canEdit}
        onSave={onSave}
      />
    </React.Fragment>
  );
}
